{
  "version": 1,
  "asset_id": "0f4ed2ab-0d07-42bc-a932-d20885b37cd2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/0f4ed2ab-0d07-42bc-a932-d20885b37cd2/sleeve-gastrectomy-v2-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/0f4ed2ab-0d07-42bc-a932-d20885b37cd2/sleeve-gastrectomy-v2-1200.webp",
  "original_filename": "sleeve-gastrectomy-v2-1200.webp",
  "size": 77324,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:47Z"
}
